import { render, staticRenderFns } from "./BillingInvoices.vue?vue&type=template&id=3da00e64"
import script from "./BillingInvoices.vue?vue&type=script&lang=js"
export * from "./BillingInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports